module.exports = __webpack_public_path__ + "common/icon-instagram-3d4d84cae3d9d5df871ea7b2386b02a6.svg";